<template>
  <div v-if="showFooter" class="footer">
    <div class="wrapper font-medium">
      <div class="module-item brand">
        <div class="logo" :class="`logo-${$store.state.locale}`">
          <img v-lazy-load v-lazy-load :data-src="logo" :alt="$t('seo.common.logoDescription')" :title="$t('common.websiteName')" height="54" :width="schoolCode === '415' ? 275 : 'auto'" loading="lazy">
        </div>
        <div v-if="$t('common.footerOtherInfo').length > 0" class="right">
          <div v-for="(otherInfo, index) in $t('common.footerOtherInfo')" :key="index" class="wasc-auth">
            <a v-if="otherInfo.link" :href="otherInfo.link" :aria-label="otherInfo.name" target="_blank">
              <img class="wasc-icon" :height="otherInfo.iconHeight" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
            </a>
            <p v-else class="wasc-name" v-html="otherInfo.name" />
            <img class="wasc-icon" :height="otherInfo.iconHeight" :width="schoolCode === '415' ? 28 : 'auto'" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
          </div>
        </div>
      </div>
      <div class="module-item links" :class="`module-item-${$store.state.locale}`">
        <template v-if="showDetail">
          <div class="main-container">
            <!-- 全球分支机构 -->
            <div v-if="otherSchools.length > 0" class="links-group-item global-branches">
              <div class="title">
                {{ otherSchool.title }}
              </div>
              <div class="branch-list">
                <a
                  v-for="(school, index) in otherSchools"
                  :key="index"
                  :class="`branch-item ${school.locale === 'hk' ? 'hk-branch-item' : ''}`"
                  :href="school.url"
                  :target="school.target"
                  rel="nofollow noopener"
                >
                  <template v-if="school.newName[locale]">
                    <template v-if="school.locale !== 'hk'">
                      <span class="flag-icon" :class="getFlagIconClass(school)">
                        <img
                          v-lazy-load :data-src="school.nationalflag"
                          :alt="school.newName[locale] || school.newName"
                          class="flag-image"
                          loading="lazy"
                        >
                      </span>

                      <span>{{ school.newName[locale] || '' }}</span>
                    </template>
                    <template v-else>
                      <div class="hk-branch-item-content">
                        <span class="flag-icon" :class="getFlagIconClass(school)">
                          <img
                            v-lazy-load :data-src="school.nationalflag"
                            :alt="chinaFlagAlt"
                            class="flag-image"
                            loading="lazy"
                          >
                        </span>
                        <div class="hk-branch-item-content-text">
                          <div class="hk-branch-item-content-text-country">China</div>
                          <span class="hk-flg-wrap">
                            <span class="hk-flag-icon">
                              <img
                                v-lazy-load data-src="../../../../assets/web/images/footer/cn-hk.png"
                                :alt="school.newName[locale] || school.newName"
                                loading="lazy"
                              >
                            </span>
                            <span class="hk-branch-item-content-text-name">{{ school.newName[locale] || '' }}</span>
                          </span>
                        </div>
                      </div>
                    </template>
                  </template>
                </a>
              </div>
            </div>
            <!-- About Us & Contact Us 合并列 -->
            <div class="links-group-item about-contact-combined">
              <!-- About Us 部分 -->
              <div class="about-section">
                <div class="title">
                  {{ aboutUs.title }}
                </div>
                <template v-for="(item, index) in aboutUs.links">
                  <a v-if="item.target" :key="index" class="hover-transition" rel="noopener" :href="item.url" :target="item.target">{{ item.name }}</a>
                  <nuxt-link v-else :key="`nuxt-link-${index}`" class="hover-transition" :to="item.url" :target="item.target" rel="noopener">
                    {{ item.name }}
                  </nuxt-link>
                </template>
              </div>

              <!-- Contact Us 部分 -->
              <template v-if="Object.keys(contactUsConfig).length">
                <!-- 邮箱&电话号 -->
                <template v-if="contactUsConfig.displayType == 'contact'">
                  <div class="contact-section">
                    <div class="title">
                      {{ contactUsConfig.title }}
                    </div>
                    <div v-if="contactList.length && locale !== 'tm'" class="contact-list">
                      <div v-for="(item, index) in contactList" :key="index" class="contact-item">
                        <div class="item-title" v-html="item.title" />
                        <div class="item-content" v-html="item.content" />
                        <div v-if="item.footer" v-html="item.footer" />
                      </div>
                    </div>
                    <div v-else class="item-group">
                      <a v-if="showContactEmail && contactEmail" class="alink-with-icon hover-transition" rel="noopener" :href="`mailto:${contactEmail}`">
                        <img class="contact-icon" v-lazy-load :data-src="mail" alt="email"><span>{{ contactEmail }}</span>
                      </a>
                      <a v-if="contactPhone && locale !== 'tm'" class="alink-with-icon hover-transition" rel="noopener" :href="`tel:${contactPhone}`">
                        <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ contactPhoneString || contactPhone }}</span>
                      </a>
                    </div>
                  </div>
                </template>
                <!-- 地址联系方式 -->
                <template v-else-if="contactUsConfig.displayType == 'address'">
                  <div class="contact-section address font-medium">
                    <div class="title">
                      {{ contactUsConfig.title }}
                    </div>
                    <div class="item-group">
                      <div v-for="(address, index) in contactUsConfig.data" :key="index" class="address-item">
                        <div class="title">
                          {{ address.title }}
                        </div>
                        <div class="desc phone">
                          <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ address.phone }}</span>
                        </div>
                        <div class="desc open-time">
                          <i class="iconfont icon-take-class-time-solid" /><span>{{ address.openTime }}</span>
                        </div>
                        <div class="desc address-desc">
                          <i class="iconfont icon-location-solid" /><span>{{ address.address }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 电话&工作时间 -->
                <template v-if="contactUsConfig.displayType == 'workTime'">
                  <div class="contact-section">
                    <div class="title">
                      {{ contactUsConfig.title }}
                    </div>
                    <div class="item-group">
                      <div v-if="contactPhone" class="contact-with-icon">
                        <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ contactPhone }}</span>
                      </div>
                      <div v-if="workingTime" class="contact-with-icon">
                        <i class="iconfont icon-take-class-time-solid" /><span>{{ workingTime }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>

            <!-- Follow Us 列 -->
            <div v-if="followsLinks.length > 0" class="links-group-item follow">
              <div class="title">
                {{ follows.title }}
              </div>
              <div class="item-group social-icons">
                <template v-for="(follow, index) in followsLinks">
                  <a v-if="follow.linkType == 'link'" :key="index" class="social-link hover-transition" rel="noopener" :href="follow.link" :target="follow.target">
                    <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                  </a>
                  <div v-else-if="follow.linkType == 'qrcode'" :key="`follow-v-else-${index}`" class="alink-with-icon has-qrcode">
                    <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                    <!-- 两个二维码特殊处理 -->
                    <div v-if="follow.linkWechat" class="qrcode-wrapper hover-transition" :class="{'is-fr': follow.linkWechat}">
                      <div>
                        <img v-lazy-load :data-src="follow.link" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                        <div v-if="follow.tipText" class="tip-text">
                          {{ follow.tipText }}
                        </div>
                      </div>
                      <div class="line" />
                      <div v-if="follow.linkWechat">
                        <img v-lazy-load :data-src="follow.linkWechat" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                        <div v-if="follow.tipTextWechat" class="tip-text">
                          {{ follow.tipTextWechat }}
                        </div>
                      </div>
                    </div>
                    <div v-else class="qrcode-wrapper hover-transition">
                      <img v-lazy-load :data-src="follow.link" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                      <div v-if="follow.tipText" class="tip-text">
                        {{ follow.tipText }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
        <!-- 协议链接 -->
        <div class="policy-links">
          <template v-for="(item, index) in policyLinks">
            <a v-if="item.target" :key="index" class="copyright-alink hover-transition" :href="item.url" :target="item.target">{{ item.name }}</a>
            <nuxt-link v-else :key="`policy-link-else-${index}`" class="copyright-alink hover-transition" :to="item.url">
              {{ item.name }}
            </nuxt-link>
          </template>
        </div>
      </div>
      <div class="module-item company-info">
        <div v-for="(companyInfoItem, companyInfoIndex) in companyInfo" :key="`companyInfoIndex-${companyInfoIndex}`" class="company-info-item">
          <template v-if="!companyInfoItem.isLink">
            <p>{{ companyInfoItem.text }}</p>
          </template>
          <template v-else>
            <a class="host-record-alink hover-transition" :href="companyInfoItem.link" target="_blank" rel="noopener">{{ companyInfoItem.text }}</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin.js';

const facebook = require('assets/images/footer/facebook.png');
const instagram = require('assets/images/footer/instagram.png');
const youtube = require('assets/images/footer/youtube.png');
// const twitter = require('assets/images/footer/facebook.png');
const linkedin = require('assets/images/footer/linkedin.png');
// const tiktok = require('assets/images/footer/facebook.png');
const wechat = require('assets/images/footer/wechat.png');
const whatsapp = require('assets/images/footer/whatsapp.png');

const mail = require('assets/images/footer/mail.png');
const phone = require('assets/images/footer/phone.png');
const logo = require('assets/images/footer/logo.png');

export default {
  mixins: [mixin],
  data() {
    return {
      logo,
      mail,
      phone,
    }
  },
  methods: {
    // 获取旗帜图标CSS类
    getFlagIconClass() {
      return ''
    },

    // 获取社交媒体图标
    getSocialIcon(iconName) {
      const socialIcons = {
        Youtube: youtube,
        Facebook: facebook,
        WeChat: wechat,
        WhatsApp: whatsapp,
        Instagram: instagram,
        LinkedIn: linkedin,
        // 'icon-instagram2': instagram,
        // 'icon-twitter2': twitter,
        // 'icon-linkedin2': linkedin,
        // 'icon-tiktok2': tiktok,
      }
      return socialIcons[iconName] || ''
    },

    // 处理图片加载错误
    // handleImageError(event) {
    //   // 当图片加载失败时，使用默认图片
    //   event.target.src = '/images/footer/uk.png'
    // }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  background: #414a51;

  .wrapper {
    font-size: 18px;
    font-family: 'Roboto-Flex';
    font-weight: 500;
    color: #fff;
    line-height: 38px;
    width: 1252px;
    margin: 0 auto;
  }
  // .module-item {
  //   &:not(:last-child) {
  //     // border-bottom: 1px solid #fff;
  //   }
  // }

  i,
  span {
    vertical-align: middle;
  }

  a {
    display: block;
    // margin: 8px 0;
    text-decoration: none;
    font-size: 18px;
    font-family: 'Roboto-Flex';
    font-weight: 500;
    color: #fff;
    line-height: 38px;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;

    &:last-child {
      margin: 8px 0 0;
    }
  }

  a:hover {
    color: #ff6b35;
  }

  .alink-with-icon {
    margin: 8px 0;
    display: flex;
    align-items: center;

    &:last-child {
      margin: 8px 0 0;
    }

    .iconfont {
      margin-right: 8px;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      color: inherit;
    }

    .contact-icon {
      margin-right: 8px;
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    &:hover {
      color: #ff6b35;

      .iconfont.icon-ins2 {
        background: linear-gradient(90deg, #ff543e 0%, #c837ab 100%);
        background-clip: text;
        color: transparent;
      }

      .iconfont.icon-ins2 + span.alink-text {
        background: linear-gradient(90deg, #ff543e 0%, #c837ab 100%);
        background-clip: text;
        color: transparent;
      }

      .iconfont.icon-wechat2 {
        color: #02ca8a;
      }

      .iconfont.icon-wechat2 + span.alink-text {
        color: #02ca8a;
      }

      .iconfont.icon-line2 {
        color: #04c300;
      }

      .iconfont.icon-line2 + span.alink-text {
        color: #04c300;
      }

      .iconfont.icon-youtube2 {
        color: #ff503f;
      }

      .iconfont.icon-youtube2 + span.alink-text {
        color: #ff503f;
      }
    }
  }

  .social-icons {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .social-link,
    .alink-with-icon {
      flex: 0 0 calc(25% - 9px);
      max-width: calc(25% - 9px);
    }

    .social-link {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      transition: all 0.3s ease;
      margin: 0;

      &:hover {
        // background: rgba(255, 107, 53, 0.2);
        transform: translateY(-2px);
      }

      .social-icon {
        width: 43px;
        height: 43px;
        object-fit: contain;
        // filter: brightness(0) invert(1);
      }
    }

    .alink-with-icon {
      .social-icon {
        width: 43px;
        height: 43px;
        object-fit: contain;
        // filter: brightness(0) invert(1);
      }
    }
  }

  .contact-with-icon {
    margin: 20px 0;

    &:last-child {
      margin: 20px 0  0;
    }

    .iconfont {
      margin-right: 6px;
      font-size: 20px;
      line-height: 20px;
      text-align: center;
      color: inherit;
    }
  }

  .module-item.brand {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 30px 0;
    padding: 85px 0 44px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);

    .logo {
      img {
        height: 54px;
        width: auto;
      }
    }

    .right {
      display: flex;
      align-items: center;

      .wasc-auth {
        display: flex;
        align-items: center;
        // margin-left: 20px;

        a {
          margin: 0;
        }

        .wasc-icon {
          display: block;
          height: 43px;
          width: 43px;
        }

        .wasc-name {
          font-family: Roboto-Flex;
          font-weight: 800;
          color: #fff;
          line-height: 32px;
          margin-right: 8px;
        }
      }
    }
  }

  .module-item.links {
    // padding: 40px 0;
    padding: 46px 0 0;

    .main-container {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      gap: 40px;
      margin: 0 auto;
    }

    .links-group-item {
      .title {
        font-size: 22px;
        font-family: Roboto-Flex;
        font-weight: 600;
        color: #fa9e00;
        line-height: 27px;
        margin-bottom: 18px;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }

      &.global-branches {
        .branch-list {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 8px 20px;
          align-items: start;
        }

        .branch-item {
          display: flex;
          align-items: flex-start;
          margin: 0;
          padding: 0;
          text-decoration: none;
          font-size: 18px;
          font-family: 'Roboto-Flex';
          font-weight: 500;
          color: #fff;
          line-height: 38px;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;

          &:hover {
            color: #ff6b35;
          }

          .flag-icon {
            margin-right: 7px;
            width: 35px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            display: inline-block;
            flex-shrink: 0;

            .flag-image {
              width: 35px;
              height: 100%;
              object-fit: contain;
              border-radius: 2px;
            }

            &.mathink {
              width: 16px;
              height: 16px;
              background: #ff6b35;
              color: #fff;
              border-radius: 2px;
              font-size: 10px;
              font-weight: bold;
              text-align: center;
              line-height: 16px;

              .flag-image {
                display: none;
              }
            }

            &.betterme {
              width: 16px;
              height: 16px;
              background: #8b5cf6;
              color: #fff;
              border-radius: 2px;
              font-size: 10px;
              font-weight: bold;
              text-align: center;
              line-height: 16px;

              .flag-image {
                display: none;
              }
            }
          }
        }

        .hk-branch-item {
          padding-top: 7px;

          .hk-branch-item-content {
            display: flex;
            align-items: stretch;

            .flag-image {
              height: 25px;
            }

            .hk-branch-item-content-text-country {
              width: 129px;
              height: 30px;
              line-height: 20px;
              border-bottom: 1px dashed #fff;
            }

            .hk-flag-icon {
              line-height: 18px;

              img {
                width: 12px;
                height: 12px;
              }
            }

            .hk-flg-wrap {
              display: flex;
              align-items: center;
              margin-top: 10px;
            }

            .hk-branch-item-content-text-name {
              margin-left: 6px;
              font-size: 16px;
              color: #cbcbcb;
              line-height: 18px;
            }
          }

          &:hover {
            .hk-branch-item-content-text-country {
              color: #fff;
            }

            .hk-branch-item-content-text-name {
              color: #ff6b35;
            }
          }
        }
      }

      &.about-contact-combined {
        .about-section {
          margin-bottom: 22px;

          .title {
            margin-bottom: 18px;
          }
        }

        .contact-section {
          .title {
            margin-bottom: 18px;
          }

          .contact-list {
            margin-top: 20px;

            .contact-item {
              color: #fff;

              .item-title {
                margin-bottom: 4px;
                display: none;
              }

              .item-content {
                // /deep/ a:hover {
                //   // color: #3370ff;
                //   color: #ff6b35;
                // }
                /deep/ a {
                  // color: #3370ff;
                  text-decoration: none;
                  font-size: 18px;
                  font-family: 'Roboto-Flex';
                  font-weight: 500;
                  color: #fff;
                  line-height: 38px;
                  // -webkit-background-clip: text;
                  // -webkit-text-fill-color: transparent;
                }
              }

              &:not(:last-child) {
                // margin: 20px 0;
              }
            }
          }

          &.address {
            .item-group {
              display: flex;
            }

            .address-item {
              flex-shrink: 0;
              margin-right: 20px;
              width: 280px;

              &:last-child {
                margin-right: 0;
              }

              .title {
                margin: 20px 0  12px;
                font-size: 14px;
                line-height: 20px;
                color: var(--txt-color-lv1);
              }

              .desc {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                color: var(--txt-color-lv2);

                &:last-child {
                  margin-bottom: 0;
                }

                &.address-desc {
                  align-items: flex-start;
                }

                &.open-time {
                  max-width: 230px;
                  align-items: flex-start;
                }

                span {
                  font-size: 12px;
                  line-height: 17px;
                }
              }

              .iconfont {
                margin-right: 5px;
                font-size: 18px;
                line-height: 18px;
                color: inherit;
              }

              .contact-icon {
                margin-right: 5px;
                width: 18px;
                height: 18px;
                object-fit: contain;
              }
            }
          }
        }
      }

      .has-qrcode {
        position: relative;
        cursor: pointer;

        .qrcode-wrapper {
          position: absolute;
          left: -190px;
          top: -70px;
          padding: 12px;
          width: 180px;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
          text-align: center;
          visibility: hidden;
          opacity: 0;

          .qrcode-img {
            display: block;
            margin: 0 auto;
            width: 150px;
            height: 150px;
            background: #f1f1f1;
          }
        }

        .is-fr {
          display: flex;
          width: auto;
          left: -345px;

          .line {
            margin-top: 26px;
            width: 1px;
            border: 1px solid #f1f1f1;
            height: 100px;
          }
        }

        .tip-text {
          margin-top: 11px;
          font-size: 12px;
          line-height: 14px;
          color: #999;
        }

        &:hover {
          .qrcode-wrapper {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }

  .module-item.module-item-us {
    // height: 541px;
  }

  .module-item.links .links-group-item.contact {
    .contact-list {
      margin-top: 20px;

      .contact-item {
        // color: rgba(34, 34, 34, 0.4);
        color: #fff;

        .item-title {
          margin-bottom: 4px;
        }

        .item-content {
          .item-title {
            font-size: 18px;
            font-family: 'Roboto-Flex';
            font-weight: 500;
            color: #fff;
            line-height: 38px;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
          }

          /deep/ p {
            font-size: 18px;
            font-family: 'Roboto-Flex';
            font-weight: 500;
            color: #fff;
            line-height: 38px;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
          }

          /deep/ a:hover {
            color: #3370ff;
          }
        }

        &:not(:last-child) {
          // margin: 20px 0;
        }
      }
    }
  }

  .module-item.links .links-group-item.contact.address {
    .item-group {
      display: flex;
    }

    .address-item {
      flex-shrink: 0;
      margin-right: 20px;
      width: 280px;

      &:last-child {
        margin-right: 0;
      }

      .title {
        margin: 20px 0  12px;
        font-size: 14px;
        line-height: 20px;
        color: var(--txt-color-lv1);
      }

      .desc {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        color: var(--txt-color-lv2);

        &:last-child {
          margin-bottom: 0;
        }

        &.address-desc {
          align-items: flex-start;
        }

        &.open-time {
          max-width: 230px;
          align-items: flex-start;
        }

        span {
          font-size: 12px;
          line-height: 17px;
        }
      }

      .iconfont {
        margin-right: 5px;
        font-size: 18px;
        line-height: 18px;
        color: inherit;
      }
    }
  }

  .module-item.links .policy-links {
    display: flex;
    text-decoration: underline;
    margin-top: 46px;
    padding-top: 22px;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    // justify-content: center;
    justify-content: flex-start;

    .copyright-alink {
      margin: 0 20px 0 0; // TODO: 修改为20px
      font-size: 18px;
      font-family: 'Roboto-Flex';
      font-weight: 500;
      color: #fff;
      line-height: 32px;
      text-decoration: underline;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
  }

  .module-item.company-info {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    font-size: 12px;
    line-height: 16px;
    color: #ccc;

    .company-info-item:only-child {
      margin: 0;
    }

    a.host-record-alink {
      margin: 0;
      color: #ccc;
    }

    a.host-record-alink:hover {
      color: #ff6b35;
    }
  }

  .safety {
    .safety-info-item {
      display: flex;
      justify-content: center;
      padding: 9px 0;
      font-size: 14px;
      line-height: 16px;
      color: rgba(34, 34, 34, 0.4);
      background-color: #eee;
      border-top: 1px solid #f5f5f5;
    }

    .safety-info-item:only-child {
      margin: 0 0 0 auto;
    }

    a.host-record-alink {
      margin: 0;
      padding: 0 5px;
      color: rgba(34, 34, 34, 0.4);
      text-decoration: underline;
    }
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  // 1440px-1919px
}

@media (min-width: 769px) and (max-width: 1439px) {
  // 769px-1439px
  .footer {
    .wrapper {
      width: 1146px;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    .wrapper {
      width: 100%;
      padding: 0 5.333vw;
    }

    .module-item {
      &:not(:last-child) {
        border-bottom: 0.267vw solid rgba(255, 255, 255, 0.5);
      }
    }

    a {
      display: block;
      color: #fff;
      text-decoration: none;
      font-size: 4.8vw;
      font-family: 'Roboto-Flex';
      font-weight: 500;
      line-height: 10.133vw;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .alink-with-icon {
      .iconfont {
        margin-right: 1.6vw;
        font-size: 5.333vw;
        line-height: 5.333vw;
        text-align: center;
        color: inherit;
      }

      .contact-icon {
        margin-right: 1.6vw;
        width: 5.333vw;
        height: 5.333vw;
        object-fit: contain;
      }
    }

    .contact-with-icon {
      margin: 5.333vw 0;

      .iconfont {
        margin-right: 1.6vw;
        font-size: 5.333vw;
        line-height: 5.333vw;
        text-align: center;
        color: inherit;
      }

      .contact-icon {
        margin-right: 1.6vw;
        width: 5.333vw;
        height: 5.333vw;
        object-fit: contain;
      }
    }

    .module-item.brand {
      padding: 22.667vw 0 11.733vw;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .logo {
        // width: 58.667vw;
        // height: 14.4vw;
        margin: 2.667vw 0;

        img {
          // width: 58.667vw;
          height: 14.4vw;
        }
      }

      .right {
        .wasc-auth {
          display: flex;
          align-items: center;
          margin-bottom: 3.2vw;

          &:last-child {
            margin-bottom: 0;
          }

          a {
            margin: 0;
          }

          .wasc-icon {
            margin-right: 2.667vw;
          }

          .wasc-name {
            // font-size: 3.2vw;
            // line-height: 3.733vw;
          }
        }
      }
    }

    .module-item.links {
      padding: 46.001px 0 0;

      .main-container {
        display: block;
        gap: 0;
        max-width: none;
        margin: 0;
      }

      .links-group-item {
        &:not(:last-child) {
          margin: 0 0 8.533vw;
        }

        .title {
          font-size: 5.867vw;
          font-family: Roboto-Flex;
          font-weight: 600;
          color: #fa9e00;
          line-height: 7.2vw;
          margin-bottom: 4.8vw;
        }

        &.global-branches {
          .branch-list {
            display: block;
            gap: 0;
          }

          .branch-item {
            display: flex;
            align-items: center;
            margin: 0 0 4.267vw;
            padding: 0;
            text-decoration: none;
            font-size: 4.8vw;
            font-family: 'Roboto-Flex';
            font-weight: 500;
            color: #fff;
            line-height: 10.133vw;

            &:hover {
              color: #ff6b35;
            }

            .flag-icon {
              margin-right: 1.867vw;
              width: 9.333vw;
              height: 6.667vw;
              text-align: center;
              display: inline-block;
              flex-shrink: 0;

              .flag-image {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 0.533vw;
              }
            }
          }

          .hk-branch-item {
            padding-top: 0;

            .hk-branch-item-content {
              display: flex;
              align-items: stretch;

              .flag-image {
                height: 6.667vw;
              }

              .hk-branch-item-content-text-country {
                width: 25.6vw;
                height: 9.3334vw;
                line-height: 6.667vw;
                border-bottom: 1px dashed #fff;
              }

              .hk-flag-icon {
                line-height: 4.8vw;

                img {
                  width: 3.2vw;
                  height: 3.2vw;
                }
              }

              .hk-flg-wrap {
                display: flex;
                align-items: center;
                margin-top: 2.9333vw;
              }

              .hk-branch-item-content-text-name {
                margin-left: 1.6vw;
                font-size: 4.266vw;
                color: #cbcbcb;
                line-height: 4.8vw;
              }
            }

            &:hover {
              .hk-branch-item-content-text-country {
                color: #fff;
              }

              .hk-branch-item-content-text-name {
                color: #ff6b35;
              }
            }
          }
        }

        &.about-contact-combined {
          .about-section {
            margin-bottom: 5.867vw;

            .title {
              margin-bottom: 4.8vw;
            }
          }

          .contact-section {
            .title {
              margin-bottom: 4.8vw;
            }

            .contact-list {
              .contact-item {
                margin: 4.267vw 0;
                color: #fff;

                .item-title {
                  color: rgba(34, 34, 34, 0.4);
                  margin-bottom: 1.067vw;
                }

                .item-content {
                  /deep/ a {
                    text-decoration: none;
                    font-size: 4.8vw;
                    font-family: 'Roboto-Flex';
                    font-weight: 500;
                    color: #fff;
                    line-height: 10.133vw;
                  }
                }
              }
            }

            &.address {
              .item-group {
                display: block;
              }

              .address-item {
                margin: 4.267vw 0;
                width: auto;

                &:not(:last-child) {
                  margin: 4.267vw 0;
                }

                .title {
                  font-size: 3.733vw;
                  line-height: 5.333vw;
                  margin: 5.333vw 0 3.2vw;
                }

                .desc {
                  display: flex;
                  align-items: center;
                  margin: 3.2vw 0;
                  font-size: 3.2vw;
                  line-height: 3.733vw;
                  color: var(--txt-color-lv2);

                  &:last-child {
                    margin: 3.2vw 0 0;
                  }

                  &.address-desc {
                    align-items: center;
                  }

                  &.open-time {
                    max-width: 58.667vw;
                    align-items: flex-start;
                  }
                }

                .iconfont {
                  margin-right: 1.333vw;
                  font-size: 4.8vw;
                  line-height: 4.8vw;
                  color: inherit;
                }

                .contact-icon {
                  margin-right: 1.333vw;
                  width: 4.8vw;
                  height: 4.8vw;
                  object-fit: contain;
                }
              }
            }
          }
        }

        &.follow {
          .social-icons {
            display: flex;
            align-items: center;
            gap: 3.2vw;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding-right: 31.2vw;

            .social-link,
            .alink-with-icon {
              flex: 0 0 calc(25% - 2.4vw);
              max-width: calc(25% - 2.4vw);
            }

            .social-link {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              transition: all 0.3s ease;
              margin: 0;

              .social-icon {
                width: 11.467vw;
                height: 11.467vw;
                object-fit: contain;
              }
            }

            .alink-with-icon {
              .social-icon {
                width: 11.467vw;
                height: 11.467vw;
                object-fit: contain;
              }
            }
          }
        }
      }

      .policy-links {
        display: flex;
        flex-wrap: wrap;
        text-decoration: underline;
        margin-top: 12.267vw;
        padding-top: 5.867vw;
        border-top: 0.267vw solid #fff;
        justify-content: flex-start;

        .copyright-alink {
          flex-shrink: 0;
          margin: 0 5.333vw 5.333vw 0;
          font-size: 4.8vw;
          font-family: 'Roboto-Flex';
          font-weight: 500;
          color: #fff;
          line-height: 8.533vw;
          text-decoration: #fff;

          &:last-child {
            margin: 0 0 5.333vw 0;
          }
        }
      }
    }

    .module-item.company-info {
      padding: 5.333vw 0;
      font-size: 4.8vw;
      font-family: 'Roboto-Flex';
      font-weight: 500;
      color: #fff;
      line-height: 8.533vw;

      .company-info-item {
        margin: 12px 0;
        text-align: center;

        &:last-child {
          margin: 12px 0 0;
        }

        p {
          margin: 0;
          word-spacing: 0;
          letter-spacing: -0.4px;
        }
      }

      a.host-record-alink {
        text-align: center;
      }
    }

    .global-branches {
      .branch-list {
        span {
          font-size: 4.8vw;
          font-family: Roboto Flex;
          font-weight: 500;
          color: #fff;
          line-height: 38px;
        }
      }
    }

    .policy-links {
      a {
        line-height: 12vw;
        margin-bottom: 0;
      }
    }
  }
}

</style>
